module.exports = __webpack_public_path__ + "static/media/iot_motion.e35544b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iot_motion.png
// module id = 212
// module chunks = 0